import React, { useState } from 'react';
import { styled, CommonStyles, Shape, Body } from '@teko/ds-foundation';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ListContentWrapper = styled.div((props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
  return [
    `
  background-color: ${(_a = props.theme) == null ? void 0 : _a.colors.white};
  padding: ${(_b = props.theme) == null ? void 0 : _b.spacing.s12} ${(_c = props.theme) == null ? void 0 : _c.spacing.s16};
  display: flex;
  align-items: center;
  position: relative;
  &.focused {
    background: ${(_d = props.theme) == null ? void 0 : _d.colors.background};
  }
  ${props.hover ? `
    background-color: ${(_e = props.theme) == null ? void 0 : _e.colors.background};
  ` : ""}
  ${props.active && !props.hover ? `
      background-color: ${(_f = props.theme) == null ? void 0 : _f.colors.primary500};
      color: ${(_g = props.theme) == null ? void 0 : _g.colors.white};
      ` : ""}
 ${props.hasDivider ? ` &:after {
      position: absolute;
      box-sizing: border-box;
      content: ' ';
      pointer-events: none;
      right: ${(_h = props.theme) == null ? void 0 : _h.spacing.s16};
      bottom: 0;
      left: ${(_i = props.theme) == null ? void 0 : _i.spacing.s16};
      border-bottom: ${(_j = props.theme) == null ? void 0 : _j.borderWeight.m} solid ${(_k = props.theme) == null ? void 0 : _k.colors.divider};
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }` : ``}
`,
    CommonStyles
  ];
});
const ListContent = (_a) => {
  var _b = _a, {
    label,
    icon,
    hasDivider = false,
    active = false,
    onClick
  } = _b, rest = __objRest(_b, [
    "label",
    "icon",
    "hasDivider",
    "active",
    "onClick"
  ]);
  var _a2, _b2;
  const [hover, setHover] = useState(false);
  return /* @__PURE__ */ React.createElement(ListContentWrapper, __spreadValues({
    onClick: () => {
      if (onClick)
        onClick();
    },
    hasDivider,
    active,
    hover,
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false)
  }, rest), icon && /* @__PURE__ */ React.createElement(Shape, {
    marginRight: "s12"
  }, React.cloneElement(icon, __spreadValues({
    size: !((_a2 = icon == null ? void 0 : icon.props) == null ? void 0 : _a2.size) ? 24 : (_b2 = icon == null ? void 0 : icon.props) == null ? void 0 : _b2.size
  }, active && !hover ? { color: "white" } : {}))), /* @__PURE__ */ React.createElement(Body, {
    level: 1,
    line: 1
  }, label));
};

export { ListContent };
